




















import { ILocale } from "@/@types/locale";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import StaandartCategoryCount from "./staandart-category-count.vue";

interface ICategory {
  _id: string;
  name: ILocale;
}

interface IList {
  category: string;
}

@Component({ components: { count: StaandartCategoryCount } })
export default class StandartCategoryTab extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Array, default: () => [] }) list!: Array<IList>;
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: String, default: "categorys" }) modal!: string;
  tabIndex = 1;

  @Watch("id")
  changeTabIndex(): void {
    if (!this.id) {
      this.tabIndex = 1;
      return;
    }
    const i = this.categorys.findIndex((el) => el._id == this.id);
    if (i < 0) {
      this.tabIndex = 1;
      return;
    }
    this.tabIndex = i + 2;
  }
}
